export default [
  { id: 'users', labelStringId: 'users', path: '/users', iconName: 'Person' },
  { id: 'invitedUsers', labelStringId: 'invitedUsers', path: '/invited-users', iconName: 'PersonAdd' },
  { id: 'cancelReasons', labelStringId: 'cancelReasons', path: '/cancel-reasons', iconName: 'Block' },
  { id: 'setup', labelStringId: 'setup', path: '/setup', iconName: 'Settings' },
];
